import { CheckIcon } from "@/Icons/Check";
import { CrossIcon } from "@/Icons/cross";

import React, { useMemo } from "react";
import Switch from "react-switch";

import { twMerge } from "tailwind-merge";

export enum LabelLocation {
  LEFT = "left",
  RIGHT = "right",
}

type Props = {
  label?: string | React.ReactNode;
  labelLocation?: LabelLocation;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  labelClassName?: string;
  width?: number;
  height?: number;
  handleDiameter?: number;
  offColor?: string;
  onColor?: string;
  offHandleColor?: string;
  onHandleColor?: string;
  trackBorderColor?: string;
  trackBorderColorChecked?: string;
};

export const Toggle: React.FC<Props> = ({
  label,
  labelLocation = LabelLocation.RIGHT,
  checked,
  onChange,
  disabled,
  labelClassName,
  width = 44,
  height = 26,
  handleDiameter = 22,
  offColor = "#948D8D",
  onColor = "#467432",
  offHandleColor,
  onHandleColor,
  trackBorderColor,
  trackBorderColorChecked,
}: Props) => {
  const labelComponent = useMemo(() => {
    if (typeof label === "string") {
      return (
        <label
          className={twMerge(
            "mx-2 text-sm",
            disabled && "text-grey6",
            labelClassName,
          )}
        >
          {label}
        </label>
      );
    }

    if (typeof label === "object") {
      return (
        <div className={twMerge("mx-2 text-sm", labelClassName)}>{label}</div>
      );
    }
    return null;
  }, [disabled, label, labelClassName]);

  const showHandleIcons = handleDiameter >= 20;
  const hasTrackBorder = !!(trackBorderColor || trackBorderColorChecked);
  const activeTrackBorderColor = checked
    ? trackBorderColorChecked
    : trackBorderColor;
  const trackBorderWidth = hasTrackBorder ? 1 : 0;

  return (
    <div className="flex items-center">
      {labelLocation === LabelLocation.LEFT && labelComponent}
      <span
        className="relative inline-flex flex-none items-center justify-center rounded-full"
        style={
          hasTrackBorder
            ? {
                border: `${trackBorderWidth}px solid ${activeTrackBorderColor}`,
              }
            : undefined
        }
      >
        <Switch
          checked={checked}
          onChange={onChange}
          offColor={offColor}
          onColor={onColor}
          offHandleColor={offHandleColor}
          onHandleColor={onHandleColor}
          disabled={disabled}
          width={width - 2 * trackBorderWidth}
          height={height - 2 * trackBorderWidth}
          handleDiameter={handleDiameter}
          className="react-switch"
          uncheckedIcon={false}
          checkedIcon={false}
          uncheckedHandleIcon={
            showHandleIcons ? (
              <div className="text-grey5 flex h-full items-center justify-center">
                <CrossIcon width={8} height={8} />
              </div>
            ) : undefined
          }
          checkedHandleIcon={
            showHandleIcons ? (
              <div className="text-carrot-green flex h-full items-center justify-center">
                <CheckIcon />
              </div>
            ) : undefined
          }
          activeBoxShadow=""
        />
      </span>
      {labelLocation === LabelLocation.RIGHT && labelComponent}
    </div>
  );
};
